export default __webpack_public_path__ + "e5e9ea9f5d9e65a00591abfe949b1bcc.svg";